<template>
    <div class="alternate-form-component-container">
        <div class="alternate-form-component-container__icon-container">
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20.3578 17.8969C19.9105 16.8496 19.2614 15.8984 18.4465 15.0961C17.6342 14.2915 16.6719 13.65 15.6128 13.207C15.6033 13.2023 15.5938 13.2 15.5844 13.1953C17.0617 12.1406 18.0221 10.4227 18.0221 8.48438C18.0221 5.27344 15.3899 2.67188 12.1412 2.67188C8.89248 2.67188 6.26031 5.27344 6.26031 8.48438C6.26031 10.4227 7.2207 12.1406 8.69803 13.1977C8.68855 13.2023 8.67906 13.2047 8.66958 13.2094C7.60723 13.6523 6.65395 14.2875 5.83585 15.0984C5.02179 15.9013 4.37275 16.8524 3.92456 17.8992C3.48426 18.924 3.24679 20.0228 3.22502 21.1359C3.22439 21.161 3.22883 21.1858 3.23808 21.2091C3.24733 21.2324 3.2612 21.2537 3.27888 21.2716C3.29656 21.2895 3.31768 21.3037 3.34102 21.3134C3.36435 21.3231 3.38941 21.3281 3.41473 21.3281H4.83752C4.94186 21.3281 5.02485 21.2461 5.02723 21.1453C5.07465 19.3359 5.80976 17.6414 7.10925 16.357C8.45379 15.0281 10.2394 14.2969 12.1412 14.2969C14.043 14.2969 15.8286 15.0281 17.1731 16.357C18.4726 17.6414 19.2077 19.3359 19.2552 21.1453C19.2575 21.2484 19.3405 21.3281 19.4449 21.3281H20.8677C20.893 21.3281 20.918 21.3231 20.9414 21.3134C20.9647 21.3037 20.9858 21.2895 21.0035 21.2716C21.0212 21.2537 21.0351 21.2324 21.0443 21.2091C21.0536 21.1858 21.058 21.161 21.0574 21.1359C21.0337 20.0156 20.7989 18.9258 20.3578 17.8969ZM12.1412 12.5156C11.0528 12.5156 10.0283 12.0961 9.25767 11.3344C8.48699 10.5727 8.06252 9.56016 8.06252 8.48438C8.06252 7.40859 8.48699 6.39609 9.25767 5.63437C10.0283 4.87266 11.0528 4.45312 12.1412 4.45312C13.2296 4.45312 14.254 4.87266 15.0247 5.63437C15.7954 6.39609 16.2199 7.40859 16.2199 8.48438C16.2199 9.56016 15.7954 10.5727 15.0247 11.3344C14.254 12.0961 13.2296 12.5156 12.1412 12.5156Z"
                    fill="#1B3C70"
                />
            </svg>
        </div>
        <div class="alternate-form-component-container__input-group">
            <ValidationProvider
                v-if="isShowingInitials"
                v-slot="{ errors }"
                :rules="initialsRules"
                tag="article"
                name="Initialen"
            >
                <AlternateFormComponent
                    v-model="name.firstName"
                    name="initials"
                    label="Initialen"
                    placeholder="Initialen"
                    :required="isRequiringInitials"
                    :hint="errors[0]"
                    :state="errors[0] ? 'error' : null"
                ></AlternateFormComponent>
            </ValidationProvider>
            <ValidationProvider
                v-else-if="isShowingFirstName"
                v-slot="{ errors }"
                :rules="firstNameRules"
                tag="article"
                name="Voornaam"
            >
                <AlternateFormComponent
                    v-model="name.firstName"
                    name="voornaam"
                    label="Voornaam"
                    placeholder="Voornaam"
                    :required="isRequiringFirstName"
                    :hint="errors[0]"
                    :state="errors[0] ? 'error' : null"
                ></AlternateFormComponent>
            </ValidationProvider>
            <ValidationProvider
                v-if="isShowingTussenvoegsel"
                v-slot="{ errors }"
                :rules="lastNamePrefixRules"
                tag="article"
                name="Tussenvoegsel"
            >
                <AlternateFormComponent
                    v-model="name.lastNamePrefix"
                    name="tussenvoegsel"
                    label="Tussenvoegsel"
                    placeholder="Tussenvoegsel"
                    :required="isRequiringTussenvoegsel"
                    :hint="errors[0]"
                    :state="errors[0] ? 'error' : null"
                ></AlternateFormComponent>
            </ValidationProvider>
            <ValidationProvider
                v-if="isShowingLastName"
                v-slot="{ errors }"
                :rules="lastNameRules"
                tag="article"
                name="Achternaam"
            >
                <AlternateFormComponent
                    v-model="name.lastName"
                    name="achternaam"
                    label="Achternaam"
                    placeholder="Achternaam"
                    :required="isRequiringLastName"
                    :hint="errors[0]"
                    :state="errors[0] ? 'error' : null"
                ></AlternateFormComponent>
            </ValidationProvider>
        </div>
    </div>
</template>

<script>
import AlternateFormComponent from './AlternateFormComponent';
import { ValidationProvider, extend } from 'vee-validate';
import { required, max, regex } from 'vee-validate/dist/rules';

extend('required', {
    ...required,
    message: '{_field_} is een verplicht veld',
});

extend('max', {
    ...max,
    message: 'Voer {_field_} correct in',
});

extend('initials', {
    validate: value => regex.validate(value, { regex: /^[a-zA-Z. ]*$/ }),
    message: 'Voer {_field_} correct in',
});

extend('first_name', {
    validate: value => regex.validate(value, { regex: /^[A-Za-zÀ-ÖØ-öø-ÿ -]*$/ }),
    message: 'Voer {_field_} correct in',
});

extend('last_name_prefix', {
    validate: value => regex.validate(value, { regex: /^[A-Za-zÀ-ÖØ-öø-ÿ ']*$/ }),
    message: 'Voer {_field_} correct in',
});

extend('last_name', {
    validate: value => regex.validate(value, { regex: /^[A-Za-zÀ-ÖØ-öø-ÿ \-']*$/ }),
    message: 'Een achternaam mag alleen letters, spaties, koppeltekens, en apostrofs bevatten.',
});

export default {
    name: 'AlternateFormName',
    components: { ValidationProvider, AlternateFormComponent },
    props: {
        value: Object,
        isShowingFirstName: {
            type: Boolean,
            default: true,
        },
        isShowingInitials: {
            type: Boolean,
            default: false,
        },
        isShowingTussenvoegsel: {
            type: Boolean,
            default: true,
        },
        isShowingLastName: {
            type: Boolean,
            default: true,
        },
        isRequiringFirstName: {
            type: Boolean,
            default: false,
        },
        isRequiringInitials: {
            type: Boolean,
            default: false,
        },
        isRequiringTussenvoegsel: {
            type: Boolean,
            default: false,
        },
        isRequiringLastName: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        const { firstName = '', lastNamePrefix = '', lastName = '' } = this.value ?? {};

        return {
            name: {
                firstName,
                lastNamePrefix,
                lastName,
            },
        };
    },
    computed: {
        initialsRules() {
            return { required: this.isRequiringInitials, max: 10, initials: true };
        },
        firstNameRules() {
            return { required: this.isRequiringFirstName, max: 20, first_name: true };
        },
        lastNamePrefixRules() {
            return { max: 20, last_name_prefix: true };
        },
        lastNameRules() {
            return { required: this.isRequiringLastName, max: 50, last_name: true };
        },
    },
    watch: {
        name: {
            handler(newVal) {
                if (newVal) {
                    this.$emit('input', newVal);
                }
            },
            deep: true,
        },
    },
};
</script>
